import React from "react";
import IconBase, { IconBaseProps } from "./IconBase";

const IconLabTest: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 16 22"
      {...props}
    >
      <path
        d="M13.0545 2.14265H11.1017C11.1017 1.3351 10.441 0.674377 9.63345 0.674377H6.3592C5.55165 0.674377 4.89093 1.3351 4.89093 2.14265H2.93812C1.87362 2.14265 1 3.01628 1 4.08077V19.3875C1 20.452 1.87362 21.3257 2.93812 21.3257H13.0619C14.1264 21.3257 15 20.452 15 19.3875V4.08077C15 3.01628 14.1264 2.14265 13.0619 2.14265H13.0545Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M9.63315 0.674377H6.3589C5.54799 0.674377 4.89062 1.33175 4.89062 2.14265C4.89062 2.95356 5.54799 3.61093 6.3589 3.61093H9.63315C10.4441 3.61093 11.1014 2.95356 11.1014 2.14265C11.1014 1.33175 10.4441 0.674377 9.63315 0.674377Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M5.15479 7.66339H11.0646"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M7.00503 7.66339V11.1505C7.00503 11.2753 6.983 11.3928 6.93161 11.5029L4.7292 16.8475C4.47959 17.4641 4.92742 18.1395 5.59548 18.1395H9.2001"
        stroke={color}
        strokeMiterlimit="10"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M9.20728 7.66339V11.1505C9.20728 11.2753 9.2293 11.3928 9.28069 11.5029L11.4831 16.8475C11.7327 17.4641 11.2849 18.1395 10.6168 18.1395H7.01221"
        stroke={color}
        strokeMiterlimit="10"
        strokeWidth="1.5"
        fill="none"
      />
    </IconBase>
  );
};

export default IconLabTest;
